var MENU_WIDTH = 44;
var GNB_HEIGHT = 45;

export { GNB_HEIGHT, MENU_WIDTH };
